/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PaymentMethodsCard,
  PaymentMethodsCard$inboundSchema,
  PaymentMethodsCard$Outbound,
  PaymentMethodsCard$outboundSchema,
} from "./paymentmethodscard.js";

export type PushToCardPaymentMethod = {
  /**
   * ID of the payment method.
   */
  paymentMethodID: string;
  paymentMethodType: "push-to-card";
  /**
   * A card as contained within a payment method.
   */
  card: PaymentMethodsCard;
};

/** @internal */
export const PushToCardPaymentMethod$inboundSchema: z.ZodType<
  PushToCardPaymentMethod,
  z.ZodTypeDef,
  unknown
> = z.object({
  paymentMethodID: z.string(),
  paymentMethodType: z.literal("push-to-card"),
  card: PaymentMethodsCard$inboundSchema,
});
/** @internal */
export type PushToCardPaymentMethod$Outbound = {
  paymentMethodID: string;
  paymentMethodType: "push-to-card";
  card: PaymentMethodsCard$Outbound;
};

/** @internal */
export const PushToCardPaymentMethod$outboundSchema: z.ZodType<
  PushToCardPaymentMethod$Outbound,
  z.ZodTypeDef,
  PushToCardPaymentMethod
> = z.object({
  paymentMethodID: z.string(),
  paymentMethodType: z.literal("push-to-card"),
  card: PaymentMethodsCard$outboundSchema,
});

export function pushToCardPaymentMethodToJSON(
  pushToCardPaymentMethod: PushToCardPaymentMethod,
): string {
  return JSON.stringify(
    PushToCardPaymentMethod$outboundSchema.parse(pushToCardPaymentMethod),
  );
}
export function pushToCardPaymentMethodFromJSON(
  jsonString: string,
): SafeParseResult<PushToCardPaymentMethod, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PushToCardPaymentMethod$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PushToCardPaymentMethod' from JSON`,
  );
}
